var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Rider Directory',"subtitle":'Edit Rider Profile'}}),(_vm.rider.uuid)?_c('rider-form',{attrs:{"banks":_vm.banks,"action":'edit',"rider":_vm.rider,"loading":_vm.loading}}):_c('eden-loader',{attrs:{"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }